import { render, staticRenderFns } from "./background-remover.vue?vue&type=template&id=c95c9350&scoped=true&"
import script from "./background-remover.vue?vue&type=script&lang=js&"
export * from "./background-remover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95c9350",
  null
  
)

export default component.exports